import type { TypeElements } from '../../types/element';

import prependChild from './prependChild';

// ----------------------------------------------------------------------------

function prependChildren<T extends Node>(parent: T, elements: TypeElements): void {
    for (const element of elements) {
        prependChild(parent, element);
    }
}

// ----------------------------------------------------------------------------

export default prependChildren;
